type AudioCtor = typeof AudioContext;

let context: AudioContext | null = null;

function getContext(): AudioContext | null {
  try {
    if (context) return context;
    const Ctor: AudioCtor | undefined = window.AudioContext;
    if (!Ctor) return null;
    context = new Ctor();
    return context;
  } catch {
    return null;
  }
}

function tone(
  frequency: number,
  duration: number,
  gainValue: number,
  type: OscillatorType = "sine",
  delay = 0,
): void {
  const ctx = getContext();
  if (!ctx) return;

  void ctx.resume().catch(() => {});
  const now = ctx.currentTime + delay;
  const oscillator = ctx.createOscillator();
  const gain = ctx.createGain();

  oscillator.type = type;
  oscillator.frequency.setValueAtTime(frequency, now);
  gain.gain.setValueAtTime(0.0001, now);
  gain.gain.exponentialRampToValueAtTime(Math.max(0.0002, gainValue), now + 0.008);
  gain.gain.exponentialRampToValueAtTime(0.0001, now + duration);

  oscillator.connect(gain);
  gain.connect(ctx.destination);
  oscillator.start(now);
  oscillator.stop(now + duration + 0.02);
}

export function primeAudio(): void {
  const ctx = getContext();
  if (!ctx) return;
  void ctx.resume().catch(() => {});
}

export function playDrawSound(): void {
  tone(160, 0.08, 0.018, "triangle");
}

export function playShotSound(): void {
  tone(96, 0.08, 0.05, "triangle");
  tone(330, 0.055, 0.018, "sine", 0.018);
}

export function playHitSound(score: number): void {
  if (score <= 0) {
    tone(118, 0.12, 0.025, "square");
    return;
  }
  const base = score >= 10 ? 740 : score >= 8 ? 620 : score >= 6 ? 520 : 420;
  tone(base, 0.12, 0.035, "sine");
  if (score >= 10) tone(base * 1.5, 0.18, 0.028, "sine", 0.045);
}
